import React from "react"
import { graphql } from "gatsby"
import {
  FaFacebookF,
  FaGoogle,
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaYelp,
  FaPinterest,
  FaTiktok,
} from "react-icons/fa"
import "./social.module.scss"

type SocialMediaBrands =
  | "Facebook"
  | "Google"
  | "Instagram"
  | "LinkedIn"
  | "Next Door"
  | "Pinterest"
  | "TikTok"
  | "Twitter"
  | "Yelp"
  | "YouTube"
  | "custom"

interface SocialIconsProps {
  href: string
  socialMediaOutlet: SocialMediaBrands
  customOutletName?: string
  customIcon?: string
  whereAmI?: string
}

export const SocialIcons = ({
  href,
  socialMediaOutlet,
  customOutletName,
  customIcon = "",
  whereAmI = "",
}: SocialIconsProps) => {
  const getSocials = (mediaOutlet: SocialMediaBrands) => {
    switch (mediaOutlet) {
      case "Instagram":
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label="instagram button"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
        )
      case "Facebook":
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label="facebook button"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>
        )
      case "Google":
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label="google button"
            target="_blank"
            rel="noreferrer"
          >
            <FaGoogle />
          </a>
        )
      case "LinkedIn":
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label="linkedin button"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedinIn />
          </a>
        )
      case "Twitter":
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label="twitter button"
            target="_blank"
            rel="noreferrer"
          >
            <FaTwitter />
          </a>
        )
      case "Yelp":
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label="yelp button"
            target="_blank"
            rel="noreferrer"
          >
            <FaYelp />
          </a>
        )
      case "YouTube":
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label="youtube button"
            target="_blank"
            rel="noreferrer"
          >
            <FaYoutube />
          </a>
        )
      case "Pinterest":
        return (
          <a
            href={href}
            className={`social-icon social-icon${whereAmI}`}
            aria-label="pinterest button"
            target="_blank"
            rel="noreferrer"
          >
            <FaPinterest />
          </a>
        )
      case "TikTok":
        return (
          <a
            href={href}
            className={`social-icon social-icon${whereAmI}`}
            aria-label="tiktok button"
            target="_blank"
            rel="noreferrer"
          >
            <FaTiktok />
          </a>
        )
      case "Next Door":
        return (
          <a
            href={href}
            className={`social-icon social-icon${whereAmI}`}
            aria-label="nextdoor button"
            target="_blank"
            rel="noreferrer"
          >
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 129.79 99.06"
              style={{ width: 22, height: "auto" }}
            >
              <defs>
                <style>{`.cls-1{fill:#fff;}`}</style>
              </defs>
              <g id="LG_GRN_LOGO" data-name="LG GRN LOGO">
                <path
                  className="cls-1"
                  d="M80.93,0c-17.82,0-33,8.18-41.52,20.7-.71,1-1.91,3.27-3.53,3.28-7.8.06-8.28-9.55-8.53-18.11A2.4,2.4,0,0,0,25,3.57L2.4,3.45A2.39,2.39,0,0,0,0,5.88C.5,26.82,4.35,41,29.72,46.69a3.05,3.05,0,0,1,2.36,3v47a2.36,2.36,0,0,0,2.38,2.37H56.39a2.39,2.39,0,0,0,2.39-2.38V48.12c0-10.78,7.65-23,22.15-23,13.82,0,22.16,12.25,22.16,23V96.68a2.39,2.39,0,0,0,2.39,2.38H127.4a2.39,2.39,0,0,0,2.39-2.38V44.52C129.79,19.58,108.51,0,80.93,0Z"
                />
              </g>
            </svg>
          </a>
        )
      default:
        if (!customIcon) {
          break
        }
        return (
          <a
            href={href}
            className={`social-icon${whereAmI}`}
            aria-label={`${customOutletName} button`}
            target="_blank"
            rel="noreferrer"
          >
            <span
              contentEditable="false"
              dangerouslySetInnerHTML={{ __html: customIcon }}
            />
          </a>
        )
    }
  }

  return <>{getSocials(socialMediaOutlet)}</>
}

export const strapiQuery = graphql`
  fragment StrapiSocialMediaFragment on STRAPI_SOCIAL_MEDIA {
    id
    social_media {
      custom_outlet
      custom_outlet_svg
      id
      link
      social_media_outlet
    }
  }
`
